import { FC } from 'react';
import * as React from 'react';
import Script from 'next/script';
import { Header as DefaultHeader } from '@zoopla/header';
import { useOptimizelyFeatureFlag } from '@zoopla/optimizely';
import { useRouter } from 'next/router';

const Header: FC<{ noShadow?: boolean }> = ({ noShadow }) => {
    const [_useLiveRamp] = useOptimizelyFeatureFlag('liveramp-consent-banner');
    const { asPath } = useRouter();

    return (
        <>
            {_useLiveRamp && (
                <Script
                    src={process.env.NEXT_PUBLIC_LIVERAMP_CMP_SCRIPT_URL}
                    strategy="beforeInteractive"
                />
            )}
            <DefaultHeader path={asPath} noShadow={noShadow} />
        </>
    );
};

export default Header;
